import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext';

/**
 * OAuth callback page. The actual code/state exchange is handled by
 * `AuthProvider`'s effect on mount (see `auth/AuthContext.tsx`). Once
 * auth status leaves `loading`, this component navigates the user away
 * — to `/` if authentication succeeded, otherwise back to `/auth/login`.
 *
 * Why not rely on AuthContext's `history.replaceState`? React Router
 * subscribes to popstate, which replaceState does not fire — so the
 * URL would change in the address bar but the router would still
 * render this page indefinitely.
 */
export function AuthCallback(): JSX.Element {
  const { status } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (status === 'authenticated') navigate('/', { replace: true });
    else if (status === 'anonymous') navigate('/auth/login', { replace: true });
  }, [status, navigate]);

  return (
    <main className="flex min-h-screen items-center justify-center bg-gray-50 p-6">
      <p className="text-sm text-gray-600">サインイン中…</p>
    </main>
  );
}
